export enum ScopeGroupPermissionType {
  View = 'view',
  Edit = 'edit',
}

export type ScopeGroup = {
  name: string;
  scopes: string[];
};

export type ScopeGroupsByPermission = {
  [ScopeGroupPermissionType.Edit]: ScopeGroup[];
  [ScopeGroupPermissionType.View]: ScopeGroup[];
};
